import { memo } from "react";
import { useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import { useUserStore } from "stores/UserStore";

import { canInvite } from "utility/misc";

import useAnalytics from "effect/use_analytics";

import LinkTab from "layouts/components/LinkTab";

import Invite from "./Invite";
import List from "./List";
import RoleDefinitions from "./RoleDefinitions";

// -----------------------------------------------------------------------------

const OrganizationMembersPage = memo(
  function OrganizationMembersPage(): JSX.Element {
    useAnalytics("Organization: Members - List");

    //
    const [userStore] = useUserStore();

    const { module } = useParams() as any;
    const moduleId = getModuleId(module);

    //
    return (
      <>
        <Typography gutterBottom variant="h4" fontWeight="bold">
          Organization Members
        </Typography>

        <Tabs value={moduleId}>
          <LinkTab label="Members" to="/organization/members" key={0} />
          {canInvite(userStore) ? (
            <LinkTab label="Invite" to="/organization/members/invite" key={1} />
          ) : null}
        </Tabs>

        <Box sx={{ mt: 3, flexGrow: 1 }}>{renderTab(moduleId)}</Box>
        <Box sx={{ mt: 2, flexGrow: 1 }}>
          {moduleId === 1 ? <RoleDefinitions /> : null}
        </Box>
      </>
    );
  }
);

export default OrganizationMembersPage;

// -----------------------------------------------------------------------------

function renderTab(value: number) {
  switch (value) {
    case 0:
      return <List />;

    case 1:
      return <Invite />;

    default:
      return <List />;
  }
}

function getModuleId(module: string): number {
  switch (module) {
    case "invite":
      return 1;

    default:
      return 0;
  }
}
